import { render } from "./FasciasWhatIs.vue?vue&type=template&id=8d038208"
import script from "./FasciasWhatIs.vue?vue&type=script&lang=js"
export * from "./FasciasWhatIs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__